import React, { useEffect, useState, memo, useRef } from "react";

const Typewriter = memo(({ text, speed = 40, onDone, ...props }) => {
  const [index, setIndex] = useState(0);
  const startTimeRef = useRef(null);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    setIndex(0);
    if (!text) return;

    startTimeRef.current = null;
    let rafId;

    const tick = (timestamp) => {
      if (startTimeRef.current === null) startTimeRef.current = timestamp;
      const elapsed = timestamp - startTimeRef.current;
      const nextIndex = Math.min(
        Math.floor(elapsed / speed),
        text.length
      );

      setIndex((prev) => (nextIndex !== prev ? nextIndex : prev));

      if (nextIndex < text.length) {
        rafId = requestAnimationFrame(tick);
      } else {
        if (onDoneRef.current) onDoneRef.current();
      }
    };

    rafId = requestAnimationFrame(tick);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [text, speed]);

  return (
    <span className="typewriter-wrapper" {...props}>
      <span className="typewriter-ghost" aria-hidden="true">
        {text}
      </span>
      <span className="typewriter-visible">{text.slice(0, index)}</span>
    </span>
  );
});

Typewriter.displayName = "Typewriter";

export default Typewriter;
